/* eslint-disable */

(function (global, factory) {
  /*!eslint-disable */
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (factory((global.DateRangePicker = {})));
  /*!eslint-enable */
}(this, (function (exports) { 'use strict';

  Date.prototype.toPtBr = function() {
    var dd = this.getDate();
    var mm = this.getMonth() + 1;

    return (dd > 9 ? '' : '0') + dd + '/' +
      (mm > 9 ? '' : '0') + mm + '/' + this.getFullYear();
  };

  Date.prototype.toEn = function() {
    var dd = this.getDate();
    var mm = this.getMonth() + 1;

    return this.getFullYear() + '/' +  (mm > 9 ? '' : '0') + mm +
      '/' + (dd > 9 ? '' : '0') + dd;
  };
  /**
   * @file A generic set of mutation-free date functions.
   */

  /**
   * now returns the current date without any time values
   *
   * @returns {Date}
   */
  function now() {
    var dt = new Date();
    dt.setHours(0, 0, 0, 0);
    return dt;
  }

  /**
   * dateEq compares two dates
   *
   * @param {Date} date1 the first date
   * @param {Date} date2 the second date
   * @returns {boolean}
   */
  function datesEq(date1, date2) {
    return (date1 && date1.toDateString()) === (date2 && date2.toDateString());
  }

  /**
   * shiftDay shifts the specified date by n days
   *
   * @param {Date} dt
   * @param {number} n
   * @returns {Date}
   */
  function shiftDay(dt, n) {
    dt = new Date(dt);
    dt.setDate(dt.getDate() + n);
    return dt;
  }

  /**
   * shiftMonth shifts the specified date by a specified number of months
   *
   * @param {Date} dt
   * @param {number} n
   * @param {boolean} wrap optional, if true, does not change year
   *                       value, defaults to false
   * @returns {Date}
   */
  function shiftMonth(dt, n, wrap) {
    dt = new Date(dt);

    var dayOfMonth = dt.getDate();
    var month = dt.getMonth() + n;

    dt.setDate(1);
    dt.setMonth(wrap ? (12 + month) % 12 : month);
    dt.setDate(dayOfMonth);

    // If dayOfMonth = 31, but the target month only has 30 or 29 or whatever...
    // head back to the max of the target month
    if (dt.getDate() < dayOfMonth) {
      dt.setDate(0);
    }

    return dt;
  }

  /**
   * shiftYear shifts the specified date by n years
   *
   * @param {Date} dt
   * @param {number} n
   * @returns {Date}
   */
  function shiftYear(dt, n) {
    dt = new Date(dt);
    dt.setFullYear(dt.getFullYear() + n);
    return dt;
  }

  /**
   * dateOrParse creates a function which, given a date or string, returns a date
   *
   * @param {function} parse the function used to parse strings
   * @returns {function}
   */
  function dateOrParse(parse) {
    return function (dt) {
      return typeof dt === 'string' ? parse(dt) : dt;
    };
  }

  /**
   * constrainDate returns dt or min/max depending on whether dt is out of bounds (inclusive)
   *
   * @export
   * @param {Date} dt
   * @param {Date} min
   * @param {Date} max
   * @returns {Date}
   */
  function constrainDate(dt, min, max) {
    return (dt < min) ? min :
           (dt > max) ? max :
           dt;
  }

  /**
   * @file Utility functions for function manipulation.
   */

  /**
   * bufferFn buffers calls to fn so they only happen every ms milliseconds
   *
   * @param {number} ms number of milliseconds
   * @param {function} fn the function to be buffered
   * @returns {function}
   */
  function bufferFn(ms, fn) {
    var timeout = undefined;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(fn, ms);
    };
  }

  /**
   * noop is a function which does nothing at all.
   */
  function noop() { }

  /**
   * copy properties from object o2 to object o1.
   *
   * @params {Object} o1
   * @params {Object} o2
   * @returns {Object}
   */
  function cp() {
    var args = arguments;
    var o1 = args[0];
    for (var i = 1; i < args.length; ++i) {
      var o2 = args[i] || {};
      for (var key in o2) {
        o1[key] = o2[key];
      }
    }
    return o1;
  }

  /**
   * @file Responsible for sanitizing and creating date picker options.
   */

  var portugueseBr = {
    days: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
    months: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
  };

  /**
   * DatePickerOptions constructs a new date picker options object, overriding
   * default values with any values specified in opts.
   *
   * @param {DatePickerOptions} opts
   * @returns {DatePickerOptions}
   */
  function DatePickerOptions(opts) {
    opts = opts || {};
    opts = cp(defaults(), opts);
    var parse = dateOrParse(opts.parse);
    opts.lang = cp(portugueseBr, opts.lang);
    opts.parse = parse;
    opts.inRange = makeInRangeFn(opts);
    opts.min = parse(opts.min || shiftYear(now(), -100));
    opts.max = parse(opts.max || shiftYear(now(), 100));
    opts.hilightedDate = opts.parse(opts.hilightedDate);

    return opts;
  }

  function defaults() {
    return {
      lang: portugueseBr,

      // Possible values: dp-modal, dp-below, dp-permanent
      shouldFocusOnRender: true,
      mode: 'dp-permanent',
      startDatePicker: true,
      multipleCalendars: true,
      startDatePickerInput: null,
      endDatePickerInput: null,
      startSelectedDate: null,
      endSelectedDate: null,
      onHide: null,

      // The date to hilight initially if the date picker has no
      // initial value.
      hilightedDate: now(),

      format: function (dt) {
        return (dt.getMonth() + 1) + '/' + dt.getDate() + '/' + dt.getFullYear();
      },

      parse: function (str) {
        var date = new Date(str);
        return isNaN(date) ? now() : date;
      },

      dateClass: function () { },

      inRange: function () {
        return true;
      }
    };
  }

  function makeInRangeFn(opts) {
    var inRange = opts.inRange; // Cache this version, and return a variant

    return function (dt, dp) {
      return inRange(dt, dp) && opts.min <= dt && opts.max >= dt;
    };
  }

  /**
   * on attaches an event handler to the specified element, and returns an
   * off function which can be used to remove the handler.
   *
   * @param {string} evt the name of the event to handle
   * @param {HTMLElement} el the element to attach to
   * @param {function} handler the event handler
   * @returns {function} the off function
   */
  function on(evt, el, handler) {
    el.addEventListener(evt, handler, true);

    return function () {
      el.removeEventListener(evt, handler, true);
    };
  }

  var CustomEvent = shimCustomEvent();

  function shimCustomEvent() {
    var CustomEvent = window.CustomEvent;

    if (typeof CustomEvent !== 'function') {
      CustomEvent = function (event, params) {
        params = params || {bubbles: false, cancelable: false, detail: undefined};
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
      };

      CustomEvent.prototype = window.Event.prototype;
    }

    return CustomEvent;
  }

  /**
   * @file Manages the calendar / day-picker view.
   */

  var dayPicker = {
    onClick: {
      'dp-day': selectDay,
      'dp-next': gotoNextMonth,
      'dp-prev': gotoPrevMonth,
      'dp-close': close,
      'dp-departure-selected-date': toChooseDepartureDate,
      'dep-selected-date-span': toChooseDepartureDate,
      'dp-returning-selected-date': toChooseReturningDate,
      'ret-selected-date-span': toChooseReturningDate,
    },
    render: render
  };

  /**
   * view renders the calendar (day picker) as an HTML string.
   *
   * @param {DatePickerContext} context the date picker being rendered
   * @returns {string}
   */
  function render(dp) {
    var opts = dp.opts;
    var lang = opts.lang;
    var state = dp.state;
    var dayNames = lang.days;
    var dayOffset = opts.dayOffset || 0;
    var selectedDate = state.selectedDate;
    var hilightedDate = state.hilightedDate;
    var hilightedMonth = hilightedDate.getMonth();

    return (
      '<div class="dp-cal">' +
        '<header class="dp-cal-title">' +
          '<span class="dp-cal-title-span">' +
            'Escolha a ' + ((opts.startDatePicker) ? 'ida' : 'volta') +
          '</span>' +
          '<a  style="background-color: none;" class="dp-close" ></a>' +
        '</header>' +
        '<header class="dp-cal-selected-dates">' +
          '<div class="selected-dates-dp">' +
            '<div class=' + ((opts.startDatePicker) ? '"dp-departure-selected-date to-select-date-picker"' : '"dp-departure-selected-date"') +'>' +
              'Data de ida <br />' +
              '<span class="dep-selected-date-span">' + (
                (opts.startSelectedDate) ? new Date(opts.startSelectedDate).toPtBr() : '-'
          ) + '</span>'+
            '</div>' +
            '<div class=' + ((!opts.startDatePicker) ? '"dp-returning-selected-date to-select-date-picker"' : '"dp-returning-selected-date"') +'>' +
              'Data de volta <br />' +
              '<span class="ret-selected-date-span">'  + (
                (opts.endSelectedDate) ? new Date(opts.endSelectedDate).toPtBr() : '-'
        ) + '</span>'+
            '</div>' +
          '</div>' +
        '</header>' +
        '<div class="dp-cal-header">' +
          '<button tabindex="-1" type="button" class="dp-prev">Prev</button>' +
          '<button tabindex="-1" type="button" class="dp-cal-month">' +
            lang.months[hilightedMonth] +
          '</button>' +
          '<button tabindex="-1" type="button" class="dp-cal-year">' +
            hilightedDate.getFullYear() +
          '</button>' +
          '<button tabindex="-1" type="button" class="dp-next">Next</button>' +
          ((!opts.multipleCalendars) ? '<button tabindex="-1" type="button" class="dp-next dp-next-single">Next</button>' : '') +
        '</div>' +
        '<div class="dp-days">' +
          dayNames.map(function (name, i) {
            return (
              '<span class="dp-col-header">' + dayNames[(i + dayOffset) % dayNames.length] + '</span>'
            );
          }).join('') +
          mapDays(hilightedDate, dayOffset, function (date) {
            var isNotInMonth = date.getMonth() !== hilightedMonth;
            var isDisabled = !opts.inRange(date);
            var className = 'dp-day';

            className += (isNotInMonth ? ' dp-edge-day' : '');
            className += (datesEq(date, hilightedDate) ? ' dp-current' : '');
            className += (datesEq(date, selectedDate)  ? ' dp-selected' : '');
            className += (isDisabled ? ' dp-day-disabled' : '');
            className += ' ' + opts.dateClass(date, dp);

            return (
              '<button tabindex="-1" type="button" class="' + className + '" data-date="' + date.getTime() + '">' +
                date.getDate() +
              '</button>'
            );
          }) +
        '</div>' +
      '</div>'
    );
  }

  function close(e, dp) {
    dp.opts.onHide();
  }

  function toChooseDepartureDate(e, dp) {
    dp.opts.startDatePickerInput.focus();
  }

  function toChooseReturningDate(e, dp) {
    dp.opts.endDatePickerInput.focus();
  }

  function gotoNextMonth(e, dp) {
    var hilightedDate = dp.state.hilightedDate;
    var newHilightedDate = shiftMonth(hilightedDate, 1);
    dp.setState({
      hilightedDate:newHilightedDate
    });
  }

  function gotoPrevMonth(e, dp) {
    var hilightedDate = dp.state.hilightedDate;
    var newHilightedDate = shiftMonth(hilightedDate, -1);


      dp.setState({
        hilightedDate: newHilightedDate
      });
  }

  function selectDay(e, dp) {
    dp.setState({
      selectedDate: new Date(parseInt(e.target.getAttribute('data-date'))),
      isStartDate: dp.opts.startDatePicker
    });
  }

  function mapDays(currentDate, dayOffset, fn) {
    var result = '';
    var iter = new Date(currentDate);
    iter.setDate(1);
    iter.setDate(1 - iter.getDay() + dayOffset);

    // If we are showing monday as the 1st of the week,
    // and the monday is the 2nd of the month, the sunday won't
    // show, so we need to shift backwards
    if (dayOffset && iter.getDate() === dayOffset + 1) {
      iter.setDate(dayOffset - 6);
    }

    // We are going to have 6 weeks always displayed to keep a consistent
    // calendar size
    for (var day = 0; day < (6 * 7); ++day) {
      result += fn(iter);
      iter.setDate(iter.getDate() + 1);
    }

    return result;
  }

  var views = {
    day: dayPicker,
  };

  function BaseMode(input, emit, opts) {
    var detatchInputEvents; // A function that detaches all events from the input
    var closing = false; // A hack to prevent calendar from re-opening when closing.
    var selectedDate; // The currently selected date
    var dp = {
      // The root DOM element for the date picker, initialized on first open.
      el: undefined,
      opts: opts,
      shouldFocusOnBlur: true,
      shouldFocusOnRender: true,
      state: initialState(),
      adjustPosition: noop,
      containerHTML: '<div class="dp"></div>',

      attachToDom: function () {
        document.body.appendChild(dp.el);
      },

      updateInput: function (selectedDate) {
        var e = new CustomEvent('change', {bubbles: true});
        e.simulated = true;
        input.value = selectedDate ? opts.format(selectedDate) : '';
        input.dispatchEvent(e);
      },

      computeSelectedDate: function () {
        return opts.parse(input.value);
      },

      currentView: function() {
        return views[dp.state.view];
      },

      open: function () {
        if (closing) {
          return;
        }

        if (!dp.el) {
          dp.el = createContainerElement(opts, dp.containerHTML);
          attachContainerEvents(dp);
        }

        selectedDate = constrainDate(dp.computeSelectedDate(), opts.min, opts.max);
        dp.state.hilightedDate = selectedDate || opts.hilightedDate;
        dp.state.view = 'day';

        dp.attachToDom();
        dp.render();

        emit('open');
      },

      hasFocus: function () {
        var focused = document.activeElement;
        return dp.el &&
          dp.el.contains(focused) &&
          focused.className.indexOf('dp-focuser') < 0;
      },

      render: function () {
        if (!dp.el) {
          return;
        }

        var hadFocus = dp.hasFocus();
        var html = dp.currentView().render(dp);
        html && (dp.el.firstChild.innerHTML = html);

        dp.adjustPosition();

        if (hadFocus || dp.shouldFocusOnRender) {
          focusCurrent(dp);
        }
      },

      // Conceptually similar to setState in React, updates
      // the view state and re-renders.
      setState: function (state) {
        for (var key in state) {
          dp.state[key] = state[key];
        }

        emit('statechange');
        dp.render();
      },
    };

    // Builds the initial view state
    // selectedDate is a special case and causes changes to hilightedDate
    // hilightedDate is set on open, so remains undefined initially
    // view is the current view (day, month, year)
    function initialState() {
      return {
        get selectedDate() {
          return selectedDate;
        },
        set selectedDate(dt) {
          if (dt && !opts.inRange(dt)) {
            return;
          }

          if (dt) {
            selectedDate = new Date(dt);
            dp.state.hilightedDate = selectedDate;
          } else {
            selectedDate = dt;
          }

          dp.updateInput(selectedDate);
          emit('select');
          // dp.close();
        },
        view: 'day',
      };
    }

    return dp;
  }

  function createContainerElement(opts, containerHTML) {
    var el = document.createElement('div');

    el.className = opts.mode;
    el.innerHTML = containerHTML;

    return el;
  }

  function focusCurrent(dp) {
    var current = dp.el.querySelector('.dp-current');
    return current && current.focus();
  }

  function attachContainerEvents(dp) {
    var el = dp.el;
    var calEl = el.querySelector('.dp');

    // Hack to get iOS to show active CSS states
    el.ontouchstart = noop;

    function onClick(e) {
      e.target.className.split(' ').forEach(function(evt) {
        var handler = dp.currentView().onClick[evt];
        handler && handler(e, dp);
      });
    }

    // The calender fires a blur event *every* time we redraw
    // this means we need to buffer the blur event to see if
    // it still has no focus after redrawing, and only then
    // do we return focus to the input. A possible other approach
    // would be to set context.redrawing = true on redraw and
    // set it to false in the blur event.

    var eventToDispatch = 'mousedown'
    on(eventToDispatch, calEl, function (e) {
      e.target.focus && e.target.focus(); // IE hack
      if (document.activeElement !== e.target) {
        e.preventDefault();
        focusCurrent(dp);
      }
    });

    on('click', el, onClick);
  }

  /**
   * @file Defines the permanent date picker behavior.
   */

  function PermanentMode(root, emit, opts) {
    var dp = BaseMode(root, emit, opts);
    dp.close = noop;
    dp.destroy = noop;
    dp.updateInput = noop;
    dp.shouldFocusOnRender = opts.shouldFocusOnRender;

    dp.computeSelectedDate = function () {
      return opts.hilightedDate;
    };

    dp.attachToDom = function () {
      root.appendChild(dp.el);
    };

    dp.open();

    return dp;
  }

  /**
   * @file Defines the various date picker modes (modal, dropdown, permanent)
   */

  function Mode(input, emit, opts) {
    input = input && input.tagName ? input : document.querySelector(input);

    return PermanentMode(input, emit, opts);
  }

  /**
   * @file Defines simple event emitter behavior.
   */

  /**
   * Emitter constructs a new emitter object which has on/off methods.
   *
   * @returns {EventEmitter}
   */
  function Emitter() {
    var handlers = {};

    function onOne(name, handler) {
      (handlers[name] = (handlers[name] || [])).push(handler);
    }

    function onMany(fns) {
      for (var name in fns) {
        onOne(name, fns[name]);
      }
    }

    return {
      on: function (name, handler) {
        if (handler) {
          onOne(name, handler);
        } else {
          onMany(name);
        }

        return this;
      },

      emit: function (name, arg) {
        (handlers[name] || []).forEach(function (handler) {
          handler(name, arg);
        });
      },

      off: function (name, handler) {
        if (!name) {
          handlers = {};
        } else if (!handler) {
          handlers[name] = [];
        } else {
          handlers[name] = (handlers[name] || []).filter(function (h) {
            return h !== handler;
          });
        }

        return this;
      }
    };
  }

  /**
   * @file The root date picker file, defines public exports for the library.
   */

  /**
  * The date picker language configuration
  * @typedef {Object} LangOptions
  * @property {Array.<string>} [days] - Days of the week
  * @property {Array.<string>} [months] - Months of the year
  * @property {string} today - The label for the 'today' button
  * @property {string} close - The label for the 'close' button
  * @property {string} clear - The label for the 'clear' button
  */

  /**
  * The configuration options for a date picker.
  *
  * @typedef {Object} DatePickerOptions
  * @property {LangOptions} [lang] - Configures the label text, defaults to portugueseBr
  * @property {('dp-modal'|'dp-below'|'dp-permanent')} [mode] - The date picker mode, defaults to 'dp-modal'
  * @property {(string|Date)} [hilightedDate] - The date to hilight if no date is selected
  * @property {function(string|Date):Date} [parse] - Parses a date, the complement of the "format" function
  * @property {function(Date):string} [format] - Formats a date for displaying to user
  * @property {function(Date):string} [dateClass] - Associates a custom CSS class with a date
  * @property {function(Date):boolean} [inRange] - Indicates whether or not a date is selectable
  * @property {(string|Date)} [min] - The minimum selectable date (inclusive, default 100 years ago)
  * @property {(string|Date)} [max] - The maximum selectable date (inclusive, default 100 years from now)
  */

  /**
  * The state values for the date picker
  *
  * @typedef {Object} DatePickerState
  * @property {string} view - The current view 'day' | 'month' | 'year'
  * @property {Date} selectedDate - The date which has been selected by the user
  * @property {Date} hilightedDate - The date which is currently hilighted / active
  */

  /**
  * An instance of TinyDatePicker
  *
  * @typedef {Object} DatePicker
  * @property {DatePickerState} state - The values currently displayed.
  * @property {function} on - Adds an event handler
  * @property {function} off - Removes an event handler
  * @property {function} setState - Changes the current state of the date picker
  * @property {function} open - Opens the date picker
  * @property {function} close - Closes the date picker
  * @property {function} destroy - Destroys the date picker (removing all handlers from the input, too)
  */

  /**
   * TinyDatePicker constructs a new date picker for the specified input
   *
   * @param {HTMLElement | string} input The input or CSS selector associated with the datepicker
   * @param {DatePickerOptions} opts The options for initializing the date picker
   * @returns {DatePicker}
   */
  function TinyDatePicker(input, opts) {
    var emitter = Emitter();
    var options = DatePickerOptions(opts);
    var mode = Mode(input, emit, options);
    var me = {
      get state() {
        return mode.state;
      },
      update: updateOptions,
      on: emitter.on,
      off: emitter.off,
      setState: mode.setState,
      open: mode.open,
      close: mode.close,
      destroy: mode.destroy,
    };

    function updateOptions(opt, newValue) {
      options[opt] = newValue;
    }

    function emit(evt) {
      emitter.emit(evt, me);
    }

    return me;
  }

  // A date range picker built on top of TinyDatePicker;

  var TinyDatePicker$1 = TinyDatePicker;

  /**
  * The state values for the date range picker
  *
  * @typedef {Object} DateRangeState
  * @property {Date} start - The start date (can be null)
  * @property {Date} end - The end date (can be null)
  */

  /**
  * An instance of TinyDatePicker
  *
  * @typedef {Object} DateRangePickerInst
  * @property {DateRangeState} state - The start / end dates
  * @property {function} on - Adds an event handler
  * @property {function} off - Removes an event handler
  * @property {function} setState - Changes the current state of the date picker
  */

  /**
   * TinyDatePicker constructs a new date picker for the specified input
   *
   * @param {HTMLElement} input The input associated with the datepicker
   * @returns {DateRangePickerInst}
   */
  function DateRangePicker(container, opts) {
    opts = opts || {};

    var emitter = Emitter();
    var root = renderInto(container, opts.endOpts.multipleCalendars);
    var hoverDate;
    var state = {
      start: undefined,
      end: undefined,
    };

    var start = TinyDatePicker(root.querySelector('.dr-cal-start'), cp({}, opts.startOpts, {
      mode: 'dp-permanent',
      dateClass: dateClass,
    }));

    var end = (opts.endOpts.multipleCalendars) ? TinyDatePicker(root.querySelector('.dr-cal-end'), cp({}, opts.endOpts, {
      mode: 'dp-permanent',
      hilightedDate: shiftMonth(start.state.hilightedDate, 1),
      dateClass: dateClass,
    })) : null;


    var handlers = {
      'statechange': onStateChange,
      'select': dateSelected,
    };

    var me = {
      state: state,
      setState: setState,
      setMinDate: setMinDate,
      setSelectedStartDate: setSelectedStartDate,
      setSelectedEndDate: setSelectedEndDate,
      setInputs: setInputs,
      on: emitter.on,
      off: emitter.off,
      rerender: rerender,
    };

    start.on(handlers);
    (end) && end.on(handlers);

    function onStateChange(_, dp) {
      // strate
      var d1 = start.state.hilightedDate;
      if (end) {
        var d2 = end.state.hilightedDate;
        var diff = diffMonths(d1, d2);

        if (diff === 1) {
          return;
        }
      }

      if (dp === start && end) {
        end.setState({
          hilightedDate: shiftMonth(dp.state.hilightedDate, 1),
        });
      } else if (end) {
        start.setState({
          hilightedDate: shiftMonth(dp.state.hilightedDate, -1),
        });
      }
    }

    function dateSelected(_, dp) {
      setTimeout(function() {
        var dt = dp.state.selectedDate;
        var isStartDate = dp.state.isStartDate;

        if (isStartDate) {
          setState({
            start: dt,
            end: (me.state.end < dt) && undefined
          })
        } else {
          setState({
            end: dt
          })
        }
      }, 0)
    }

    function setInputs(startInput, endInput) {
      start.update('startDatePickerInput', startInput);
      if (endInput) {
        start.update('endDatePickerInput', endInput);
      }
      rerender();
    }

    function setMinDate(newDate) {
      start.update('min', newDate);
      start.setState({
        hilightedDate: shiftMonth(newDate, (end) ? 0 : 0),
      });
      (end) && end.update('min', newDate);
      rerender();
    }

    function setSelectedStartDate(newDate) {
      start.update('startSelectedDate', newDate);
      (end) && end.update('startSelectedDate', newDate);

      if (newDate && end) {
          end.setState({
              hilightedDate: shiftMonth(newDate, 1),
          });
      }
      rerender();
    }

    function setSelectedEndDate(newDate) {
      start.update('endSelectedDate', newDate);
      (end) && end.update('endSelectedDate', newDate);
      if (newDate) {
        start.setState({
          hilightedDate: newDate,
        });
      }
      rerender();
    }


    function setState(newState) {
      for (var key in newState) {
        state[key] = newState[key];
      }

      emitter.emit('statechange', me);
      rerender();
    }

    function rerender() {
      start.setState({});
      (end) && end.setState({});
      if (!/iPhone|iPad|iPod/i.test(navigator.userAgent)) {

      }
    }

    // Hack to avoid a situation where iOS requires double-clicking to select
    if (!/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      root.addEventListener('mouseover', function mouseOverDate(e) {
        if (e.target.classList.contains('dp-day')) {
          var dt = new Date(parseInt(e.target.dataset.date));
          var changed = !datesEq(dt, hoverDate);

          if (changed) {
            hoverDate = dt;

            if (!opts.startOpts.startDatePicker || (opts.startOpts.startDatePicker && state.end))  {
              rerender();
            }
          }
        }
      });
    }

    function dateClass(dt) {
      var rangeClass = (state.end || hoverDate) &&
                       state.start &&
                       inRange(dt, state.end || hoverDate, state.start);

      var selectedClass = (datesEq(dt, state.start) ? 'dr-selected-start' : datesEq(dt, state.end) ? 'dr-selected-end': '');

      return (rangeClass ? 'dr-in-range ' : '') + selectedClass;
    }

    return me;
  }

  function renderInto(container, multiplePickers) {
    if (typeof container === 'string') {
      container = document.querySelector(container);
    }

    container.innerHTML = '<div class="dr-cals">' +
      '<div class="dr-cal-start"></div>' +
      ((multiplePickers) ? '<div class="dr-cal-end"></div>' : '') +
      '</div>';

    return container.querySelector('.dr-cals');
  }

  function toMonths(dt) {
    return (dt.getYear() * 12) + dt.getMonth();
  }

  function diffMonths(d1, d2) {
    return toMonths(d2) - toMonths(d1);
  }

  function inRange(dt, start, end) {
    return (dt < end && dt >= start) || (dt <= start && dt > end);
  }

  exports.TinyDatePicker = TinyDatePicker$1;
  exports.DateRangePicker = DateRangePicker;

  Object.defineProperty(exports, '__esModule', { value: true });

})));



// WEBPACK FOOTER //
// ./src/lib/date-range-picker.js